import validUrl from 'valid-url';

/* eslint max-len: 0 */
export const BasicValidation = {
  required: (field, value, prop) => (prop ? !value : false),

  minLength: (field, value, prop) => (prop && value ? value.length < prop : false),

  maxLength: (field, value, prop) => (prop && value ? value.length > prop : false),

  email: (field, value, prop) => (prop && value ? !(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(value)) : false),

  min: (field, value, prop) => (prop && value ? !isFinite(value) || parseFloat(value) < prop : false),

  max: (field, value, prop) => (prop && value ? !isFinite(value) || parseFloat(value) > prop : false),

  pattern: (field, value, prop) => (!value ? false : !prop.test(value)),

  equalTo: (field, value, prop) => (!value ? false : prop !== value),

  oneOf: (field, value, prop) => (!value ? false : prop.indexOf(value) === -1),

  url: (field, value) => (!value ? false : !validUrl.isUri(value)),

  promise: (field, value, prop, dispatch, values, validation, props, blurredField) => {
    if (typeof prop === 'function') {
      return prop(field, value, dispatch, values, validation, props, blurredField);
    }
    throw new Error('FormValidation: type promise must be a function!');
  },

  digits: (field, value) => (!field || !/^\d+$/.test(value)),

  matchField: (field, value, prop, dispatch, allValues) => {
    if (!value) {
      return false;
    }
    const propValue = (typeof allValues.get === 'function' ? allValues.get(prop) : allValues[prop]); // immutableJS
    if (value !== propValue) {
      return true;
    }
    return false;
  },
};
